export default __webpack_public_path__ + "static/Construction-Debris-Removal-84e4926542b37af2ddb8afb5c1b1cd6b.jpg";